import React from "react";
import './notFoundPage.css'
import { images } from '../../constants';

const NotFoundPage = () => {
  const handleBack = () => {
    window.history.back()
  };

  return (
    <div className="content">
      <img src={images.not_found} alt="Page Not Found"/>
      <h1>The page you are looking for does not exist.</h1>
      <button className="back-button" onClick={handleBack}>
        Go Back
      </button>
    </div>
  );
};

export default NotFoundPage;
